import React from 'react';
import { Grid, Popover, Alert } from '@mui/material';

const ErrorMessage = (properties: {
  open: boolean;
  element: any;
  handleClose: Function;
  message: string;
}) => {
  const { open, element, handleClose, message } = properties;

  return (
    <Popover
      id="errorPopover"
      open={open}
      anchorEl={element}
      onClose={() => handleClose()}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <Grid direction="row" justifyContent="flex-start" container>
        <Alert severity="error">{message}</Alert>
      </Grid>
    </Popover>
  );
};

export default ErrorMessage;
